const initialState = {}

export const reportsFilter = (state = initialState, action :any) => {
  switch (action.type) {
    case 'SET_REPORTS_FILTER':
      return { ...state, ...action.payload }
    default:
      return state
  }
}